import { WCPledgeTutorial3DImage1 } from '@capsicum/common';
import { CondensedButton, Image, ListCard, Timer, useRTL } from '@capsicum/common-web';
import {
	useWCPledgeButtonProperties,
	useWCPledgeCardTexts,
	useWCPledgeRibbonProperties
} from '@capsicum/features/nc-wallet/shared';
import { WCPledgeStatus } from '@capsicum/features/world-championship-pledge/shared';
import { useWCPledgeRequirementsModal } from '@capsicum/features/world-championship-pledge/web';
import styled from 'styled-components';

export const WCPledgeCard = () => {
	// TODO: Ultimately these should be sent by BE and not defined here
	const status = WCPledgeStatus.OPENED;
	const endDate = null;
	const { isRTL } = useRTL();

	const { WCPledgeCardFirstSubtitle, WCPledgeCardSecondSubtitle, WCPledgeCardTitle } = useWCPledgeCardTexts();
	const { onJoinWCPledge } = useWCPledgeRequirementsModal(status);

	const {
		endDate: timerEndDate,
		shouldShowTimer,
		WCPledgeCardRibbonColor,
		WCPledgeCardRibbonText
	} = useWCPledgeRibbonProperties(status, endDate);

	const { WCPledgeCardButtonText } = useWCPledgeButtonProperties(status);
	const { RibbonText } = ListCard.Ribbon;

	const cardRibbon = shouldShowTimer ? (
		<ListCard.Ribbon backgroundColor={WCPledgeCardRibbonColor}>
			<RibbonText isBold>{WCPledgeCardRibbonText}</RibbonText>
			<S.TimerWrapper $isRTL={isRTL}>
				<Timer expirationDate={timerEndDate!} size="xsmall" />
			</S.TimerWrapper>
		</ListCard.Ribbon>
	) : (
		<ListCard.Ribbon backgroundColor={WCPledgeCardRibbonColor}>
			<RibbonText isBold>{WCPledgeCardRibbonText}</RibbonText>
		</ListCard.Ribbon>
	);

	return (
		<S.ListCardWCPledge testID="worldChampionshipPledge-walletCard" onClick={onJoinWCPledge}>
			{cardRibbon}
			<S.Container>
				<S.StartContainer>
					<Image
						alt="World Championship Pledge Card Image"
						height={96}
						src={WCPledgeTutorial3DImage1}
						style={{ objectFit: 'cover' }}
						width={76}
					/>
				</S.StartContainer>
				<S.CardBody>
					<ListCard.Row>
						<ListCard.Title>{WCPledgeCardTitle}</ListCard.Title>
					</ListCard.Row>
					<ListCard.Row>
						<S.Subtitle>{WCPledgeCardFirstSubtitle}</S.Subtitle>
					</ListCard.Row>
					<ListCard.Row>
						<S.Subtitle>{WCPledgeCardSecondSubtitle}</S.Subtitle>
						<S.ButtonWrapper>
							<CondensedButton
								color="brand"
								size="small"
								testID="worldChampionshipPledge-enterButton"
								text={WCPledgeCardButtonText}
								textSize="xsmall"
								onClick={e => onJoinWCPledge(e)}
							/>
						</S.ButtonWrapper>
					</ListCard.Row>
				</S.CardBody>
			</S.Container>
		</S.ListCardWCPledge>
	);
};

namespace S {
	export const ListCardWCPledge = styled(ListCard)<{ $fullWidth?: boolean }>`
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		margin-bottom: ${({ theme }) => theme.spacings.xsmall};
		${({ $fullWidth }) => $fullWidth && `width: 100%;`}
	`;

	export const Container = styled.div`
		display: flex;
		flex-direction: row;
		width: 100%;
		padding: ${({ theme }) => `${theme.spacings.small} ${theme.spacings.xxsmall}`};
	`;

	export const CardBody = styled(ListCard.Content)`
		padding: 0;
	`;

	// atoms use a align-items: center, so we need to override it
	export const StartContainer = styled(ListCard.Start)`
		align-items: flex-start;
	`;

	export const Subtitle = styled.div`
		display: flex;
		flex-direction: column;
		gap: ${({ theme }) => theme.spacings.xxxsmall};
		align-items: baseline;
		color: ${({ theme }) => theme.colors.text.main.subtle};
		width: 100%;
		${({ theme }) => theme.fonts.text.text5}
	`;

	export const ButtonWrapper = styled.div`
		display: flex;
		flex-direction: row;
		justify-content: flex-end;
		width: 100%;
	`;

	export const TimerWrapper = styled.span<{ $isRTL: boolean }>`
		margin-left: ${({ theme }) => theme.spacings.xxxsmall};
		${({ $isRTL, theme }) =>
			$isRTL &&
			`
				margin-left: 0;
				margin-right: ${theme.spacings.xxxsmall};
			`}
	`;
}
